module.exports = __webpack_public_path__ + "media/images/temp/ribbon-10-74855ab97f0d7824851068c1758c2572.png";